import { EPartnerRewardsSource } from '@cian/feedback-form-widget';

import { createStaticReducer } from '../../../../packages/redux-utils';

const defaultState: EPartnerRewardsSource | null = null;

export const partnerRewardsSourceReducer = createStaticReducer<EPartnerRewardsSource | null>(defaultState);
